import React from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getUserData } from '../selectors/user';
import EnvironmentBanner from './components/EnvironmentBanner';
import AuditReportButton from './components/AuditReportButton';
import SavedReportsPanel from './components/SavedReportsPanel';
import TrialChip from './components/TrialChip';
import FreeTierChip from './components/FreeTierChip';
import AdminActions from './components/AdminActions';
import AccountWidget from './components/AccountWidget';
import HelpMenu from './components/HelpMenu';
import IntercomBell from './components/IntercomBell';
import NotificationIndicator from './components/NotificationIndicator';
import LanguageSelector from './components/LanguageSelector';
import { SINGULAR_LOGO, SINGULAR_LOGO_ICON } from './consts';
import css from './style.css';

function Topbar() {
    const userData = useSelector(getUserData) || {};
    const container = document.getElementById('topbar');

    if (!container) {
        return null;
    }

    const loaded = !!userData.email;

    const bar = (
        <nav className={css.topbar}>
            <div className={css.topbarLeft}>
                <a className={classNames(css.logo, css.logoFull)} href="#/">
                    <img src={SINGULAR_LOGO} alt="Singular Logo" />
                </a>
                <a className={classNames(css.logo, css.logoIconOnly)} href="#/">
                    <img src={SINGULAR_LOGO_ICON} alt="Singular Logo" />
                </a>
                {loaded && <EnvironmentBanner area="left" />}
            </div>
            {loaded && (
                <div className={css.topbarCenter}>
                    <EnvironmentBanner area="center" />
                </div>
            )}
            {loaded && (
                <div className={css.topbarRight}>
                    <AuditReportButton />
                    <SavedReportsPanel />
                    <TrialChip />
                    <FreeTierChip />
                    <div className={classNames(css.inlineGroup, css.hideBelowMd)}>
                        <AdminActions />
                    </div>
                    <AccountWidget />
                    <div className={classNames(css.inlineGroup, css.hideBelowMd)}>
                        <HelpMenu />
                        <IntercomBell />
                        <NotificationIndicator />
                        <LanguageSelector />
                    </div>
                </div>
            )}
        </nav>
    );

    return createPortal(bar, container);
}

export default Topbar;
